<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="main">
    <section class="hero-section">
      <div class="content">
        <h1>Navigator™ for Drug Labels</h1>
        <h3>Already have an account?</h3>
        <a
          class="cta-button"
          href="https://navdruglabels.reedtech.com/"
          target="_blank"
          >LOGIN</a
        >
      </div>
    </section>
    <section class="info-section row">
      <div class="text-content col-md-6">
        <h2>
          Navigator™ for Drug Labels combines US and centralized EU human drug
          label databases with advanced search, comparison, analysis, and alerts
          tools
        </h2>
        <ul>
          <li>Access historical and current drug labels</li>
          <li>Branded and generic prescription drugs</li>
          <li>Biologics and over-the-counter (OTC)</li>
          <li>Homeopathic and herbal products</li>
          <li>Set up alerts for updates in your Personal Library</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="image position-relative flex align-items-center">
          <img
            src="https://i.ytimg.com/vi/aDp7Qx1Za_U/maxresdefault.jpg"
            alt="Image of Navigator™ for Drug Labels"
          />
          <a
            href="https://youtu.be/aDp7Qx1Za_U"
            target="_blank"
            class="position-absolute play-icon"
          >
            <i class="fa-solid fa-play"></i>
          </a>
        </div>
      </div>
    </section>
    <section class="features-section">
      <h2 class="features-title">Navigator™ for Drug Labels Features</h2>
      <div class="row">
        <div class="col-md-6 feature">
          <h4><strong>Regulatory Intelligence</strong></h4>
          <p>
            Research and produce labels in line with corporate and industry
            standards.
          </p>
          <ul>
            <li>
              Conduct advanced searches of comprehensive US (Rx, OT, and
              homeopathic) and EU-centralised (Rx) human drug label databases
            </li>
            <li>
              Access nearly 500,000 historical and current drug labels, compare
              them side-by-side, and monitor them for changes
            </li>
            <li>
              Be confident in the most current, comprehensive information
              available with daily database updates
            </li>
          </ul>
        </div>
        <div class="col-md-6 feature">
          <h4><strong>Streamlined Label Creation</strong></h4>
          <p>
            Research and produce labels in line with corporate and industry
            standards.
          </p>
          <ul>
            <li>
              Ensure global locations produce labels in line with corporate
              standards and industry standards
            </li>
            <li>
              Compare up to five labels at a time by section as well previous
              versions of a drug label
            </li>
            <li>
              Track label updates to ensure consistent data and formatting
              across multiple suppliers
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 feature">
          <h4><strong>Market Research</strong></h4>
          <p>
            Bolster your market research efforts with insights into competitor
            products and reference drugs.
          </p>
          <ul>
            <li>
              Perform due diligence for acquisitions or new product development
            </li>
            <li>Gain actionable insights into competitors’ products</li>
            <li>Establish a competitive advantage</li>
          </ul>
        </div>
        <div class="col-md-6 feature">
          <h4><strong>Case Development and Litigation</strong></h4>
          <p>
            Research and procure documentation to support case development and
            litigation
          </p>
          <ul>
            <li>Support case development and due diligence</li>
            <li>
              Perform language analysis to determine acceptable communications
            </li>
            <li>Research language changes by label version</li>
          </ul>
        </div>
      </div>
    </section>
    <section class="contact-section">
      <h2>Send Us a Message</h2>
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-6">
            <label for="firstName" class="required-label">First Name</label>
            <input
              id="firstName"
              formControlName="firstName"
              type="text"
              class="form-control"
              required
            />
          </div>
          <div class="col-md-6">
            <label for="lastName" class="required-label">Last Name</label>
            <input
              id="lastName"
              formControlName="lastName"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="email" class="required-label">Email</label>
            <input
              id="email"
              formControlName="email"
              type="email"
              class="form-control"
              required
            />
          </div>
          <div class="col-md-6">
            <label for="phoneNumber" class="required-label">Phone Number</label>
            <input
              id="phoneNumber"
              formControlName="phoneNumber"
              type="tel"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="jobTitle" class="required-label">Job Title</label>
            <input
              id="jobTitle"
              formControlName="jobTitle"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="companyName" class="required-label">Company Name</label>
            <input
              id="companyName"
              formControlName="companyName"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label tabindex="0" aria-label="Select country or region" class="required-label"
              >Country/Region</label
            >
            <ejs-dropdownlist
              #country
              [dataSource]="countryLOV"
              aria-label="country dropdown"
              aria-required="required"
              role="list"
              [fields]="ddwFields"
              [placeholder]="countryWaterMark"
              [popupHeight]="ddwHeight"
              formControlName="country"
            >
            </ejs-dropdownlist>
          </div>
        </div>
        <div class="row">
          <label class="required-label">What industry are you in?</label>
          <div>
            <input type="checkbox" formControlName="medicalDevice" /> Medical
            Device
          </div>
          <div>
            <input type="checkbox" formControlName="pharmaceutical" />
            Pharmaceutical
          </div>
          <div>
            <input type="checkbox" formControlName="consumerOtc" /> Consumer OTC
          </div>
          <div>
            <input type="checkbox" formControlName="cosmetics" /> Cosmetics
          </div>
        </div>
        <div class="row">
          <label>Are you interested in a demo?</label>
          <div>
            <input type="radio" formControlName="demo" [value]="true" /> Yes
          </div>
          <div>
            <input type="radio" formControlName="demo" [value]="false" /> No
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="comments"
              >How can we help? Are there specific regulatory advisory topics
              you are inquiring about? Tell us a little about your
              project.</label
            >
            <textarea
              id="comments"
              formControlName="comments"
              rows="4"
              class="form-control"
            ></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p><a href="https://corporate.reedtech.com/contact/" rel="noopener" target="_blank">Reed Tech</a>,
              a <a href="https://www.lexisnexis.com/en-us/gateway.page" rel="noopener" target="_blank">LexisNexis</a>
              company, may contact you in your professional capacity with information about our other products,
              services and events that we believe may be of interest. You'll be able to update your communication
              preferences any time by clicking on the unsubscribe link provided within our communications.
              You can learn more about how we handle your personal data and your rights by reviewing our
              <a href="https://www.lexisnexis.com/en-us/terms/privacy-policy.page" rel="noopener" target="_blank">Privacy Policy
              </a>.</p>
          </div>
        </div>
        <button type="submit" class="btn btn-primary submit">SUBMIT</button>
      </form>
    </section>
    <br/>
    <div *ngIf="loading">
      <div id="loading"></div>
    </div>
  </div>
</main>
